import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash'; // eslint-disable-line
import { Field, reduxForm, FieldArray, formValueSelector, reset } from 'redux-form';
import { RenderField, RenderSelectField, RenderSubmitButton, RenderCheckboxRadioField, RenderDropdownSelect } from '../../../common/form'; // eslint-disable-line
import GuestAffiliation from '../GuestAffiliation';
import * as Validations from '../../../common/form/commonValidations';
import { addGuestFromRequestNotification, grabGuestByUuid, getGuestRequests } from '../../../../actions/PublicWebsiteActions';
import { Prefix } from '../GuestListTypes';
import { truncateText } from '../../../../util/textUtil';
import './AddGuestPage.less';


class RenderGuestRow extends Component {
  constructor(props) {
    super(props);

    this.getGuestValue = this.getGuestValue.bind(this);
    this.getFirstNameRequiredProps = this.getFirstNameRequiredProps.bind(this);
    this.getFamilyNameRequiredProps = this.getFamilyNameRequiredProps.bind(this);
    this.renderPrefixInput = this.renderPrefixInput.bind(this);
  }

  getGuestValue(name, index) {
    const { guestFormValues } = this.props;
    return guestFormValues && guestFormValues[index] && guestFormValues[index][name];
  }

  getFirstNameRequiredProps(index) {
    return this.getGuestValue('plus_one', index) ? {} : {
      required: true,
      validate: Validations.REQUIRED,
    };
  }

  getFamilyNameRequiredProps(index) {
    const isPrimary = this.getGuestValue('relationship_type', index) === 'PRIMARY';
    return isPrimary ? { required: true, validate: Validations.REQUIRED } : {};
  }

  renderPrefixInput(guest, index) {
    if (this.getGuestValue('relationship_type', index) === 'CHILD') {
      return (
        <input className="form-control" value="Child" disabled />
      );
    } if (this.getGuestValue('name_unknown', index)) {
      return (
        <input className="form-control" value="Guest" disabled />
      );
    }
    return (
      <Field
        name={`${guest}.prefix`}
        id="add-guest-group-prefix"
        options={Prefix}
        component={RenderDropdownSelect}
        hideFormGroup
        tooltip="Addressing your invitations formally? Include titles for your guests."
      />
    );
  }

  render() {
    const { name, index, fields, enableChildren } = this.props;
    const guest = name;
    const isPrimary = this.getGuestValue('relationship_type', index) === 'PRIMARY'; // eslint-disable-line
    const nameUnknown = this.getGuestValue('name_unknown', index);
    return (
      <div key={index} className="row form-group">
        <div className="col-xs-12 col-md-2">
          <div className="visible-xs visible-sm text-left">
            <div className="with-tooltip" data-tooltip="Addressing your invitations formally? Include titles for your guests.">
              <div className="form-label">
                Title <i className="zolaicon zolaicon-info" />
              </div>
            </div>
            {this.renderPrefixInput(guest, index)}
          </div>
          <div className="hidden-xs hidden-sm">
            {this.renderPrefixInput(guest, index)}
          </div>
        </div>
        <div className="col-xs-12 col-md-4">
          <div className="visible-xs visible-sm text-left margin-top">
            <div className="form-label">First Name</div>
          </div>
          {nameUnknown && (
            <input className="form-control" type="text" disabled />
          )}
          {!nameUnknown && (
            <Field
              name={`${guest}.first_name`}
              id="add-guest-group-first-name"
              type="text"
              component={RenderField}
              {...this.getFirstNameRequiredProps(index)}
              disabled={nameUnknown}
              hideValue={nameUnknown}
              hideFormGroup
            />
          )}
        </div>
        <div className="col-xs-12 col-md-4 text-left">
          <div className="visible-xs visible-sm margin-top">
            <div className="form-label">Last Name</div>
          </div>
          {nameUnknown && (
            <input className="form-control" type="text" disabled />
          )}
          {!nameUnknown && (
            <Field
              name={`${guest}.family_name`}
              id="add-guest-group-family-name"
              type="text"
              component={RenderField}
              {...this.getFamilyNameRequiredProps(index)}
              disabled={nameUnknown}
              hideFormGroup
            />
          )}
        </div>
        <div className="col-xs-12 col-md-2 visible-xs visible-sm text-left margin-top">
          <div className="form-label">Suffix</div>
          {index > 0 && (
            <div className="guest-delete" onClick={() => fields.remove(index)}>X</div>
          )}
          {nameUnknown && (
            <input className="form-control" type="text" disabled />
          )}
          {!nameUnknown && (
            <Field
              name={`${guest}.suffix`}
              id="add-guest-group-suffix"
              type="text"
              component={RenderField}
              disabled={nameUnknown}
              hideFormGroup
            />
          )}
        </div>
        <div className="col-xs-12 col-md-2 hidden-xs hidden-sm">
          {index > 0 && (
            <div className="guest-delete" onClick={() => fields.remove(index)}>
              <div className="with-tooltip" data-tooltip="Delete guest">X</div>
            </div>
          )}
          {nameUnknown && (
            <input className="form-control" type="text" disabled />
          )}
          {!nameUnknown && (
            <Field
              name={`${guest}.suffix`}
              id="add-guest-group-suffix"
              type="text"
              component={RenderField}
              disabled={nameUnknown}
              hideFormGroup
            />
          )}
        </div>
        {index > 0 && (
          <div className="col-xs-12">
            <div className="with-tooltip" data-tooltip="Check off if you don't know a guest's or plus-one's name.">
              <Field
                id={`${guest}-add-guest-group-name-unknown`}
                name={`${guest}.name_unknown`}
                component={RenderCheckboxRadioField}
                type="checkbox"
                label="Name Unknown"
                styleOverride
                className="col-xs-10 col-md-12"
              />
              <span className="zolaicon zolaicon-info guest-unknown-zolaicon visible-xs visible-sm col-xs-2" />
            </div>
          </div>
        )}
        {(index === 0) && !(fields.get(index + 1) && (fields.get(index + 1).relationship_type === 'PARTNER')) && (
          <div className="col-xs-12 margin-top text-left">
            <div className="with-tooltip" data-tooltip="Control who brings a plus-one.">
              <a role="button" className="plus-one-btn" onClick={() => fields.insert(1, { relationship_type: 'PARTNER', source: 'MANUAL' })}>+ Add Plus One</a>
              <i className="zolaicon zolaicon-info visible-xs-inline visible-sm-inline margin-left-2x" />
            </div>
          </div>
        )}
        {enableChildren && (index === fields.length - 1) && (
          <div className="col-xs-12">
            <a role="button" onClick={() => fields.push({ relationship_type: 'CHILD', source: 'MANUAL' })}>+ Add Child</a>
          </div>
        )}
      </div>
    );
  }
}

RenderGuestRow.propTypes = {
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  fields: PropTypes.shape({}).isRequired,
  guestFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  enableChildren: PropTypes.bool,
  // guestRequestNotifications: PropTypes.arrayOf(
  //   PropTypes.shape({})
  // )
};

const RenderGuests = ({ fields, template, guestFormValues }) => {
  const enableChildren = template === 'SINGLE';
  return (
    <div>
      <div className="row hidden-xs hidden-sm">
        <div className="col-md-2">
          <div className="form-label">Title</div>
        </div>
        <div className="col-md-4">
          <div className="form-label">First Name</div>
        </div>
        <div className="col-md-4">
          <div className="form-label">Last Name</div>
        </div>
        <div className="col-md-2">
          <div className="form-label">Suffix</div>
        </div>
      </div>
      {fields.map((guestNameField, guestIndex, guestFieldsRef) => (
        <RenderGuestRow
          key={guestIndex}
          name={guestNameField}
          index={guestIndex}
          fields={guestFieldsRef}
          guestFormValues={guestFormValues}
          enableChildren={enableChildren}
        />
      ))}
    </div>
  );
};

RenderGuests.propTypes = {
  template: PropTypes.string,
  fields: PropTypes.shape({}),
  guestFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  // guestRequestNotifications: PropTypes.arrayOf(
  //   PropTypes.shape({})
  // )
};

function RenderEventInvitation({ eventInvitation, formValues, index, disabled }) {
  return (
    <Field
      id={eventInvitation}
      name={`${eventInvitation}.checked`}
      component={RenderCheckboxRadioField}
      label={formValues && truncateText(formValues[index].name, 30)}
      type="checkbox"
      styleOverride
      inline
      className={disabled ? 'checkbox-disabled event-checkbox' : 'checkbox-secondary event-checkbox'}
      disabled={disabled}
    />
  );
}

RenderEventInvitation.propTypes = {
  eventInvitation: PropTypes.string,
  index: PropTypes.number,
  formValues: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
};

function RenderEventInvitations({ fields, id, label, hideFormGroup, meta: { touched, error }, formValues, disabled }) {
  return (
    <div className={`${hideFormGroup ? '' : 'form-group'} ${disabled ? 'event-invitations-disabled' : ''} ${touched && error ? 'has-error' : ''}`}>
      <label htmlFor={id} className="margin-right-2x invite-label">{label}</label>
      <div id={id} className="visible-xs visible-sm-inline visible-md-inline visible-lg-inline">
        {fields.map((eventInvitation, index, fieldsRef) => (
          <RenderEventInvitation
            key={index}
            eventInvitation={eventInvitation}
            index={index}
            fields={fieldsRef}
            formValues={formValues}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
}

RenderEventInvitations.propTypes = {
  fields: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.string,
  hideFormGroup: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  formValues: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
};

class AddGuestGroupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false
    };
  }

  componentWillMount() {
    const { params, grabGuest } = this.props;
    const { rsvpUUID } = params;
    grabGuest(rsvpUUID);
  }

  render() {
    const { wedding, template, guestFormValues, eventFormValues, handleSubmit, pristine, submitting, valid, invitedFormValue } = this.props;
    return (
      <div className="add-guest-page-container">
        <div className="main-content text-left">
          <h1>Add Guests</h1>
        </div>
        <form onSubmit={handleSubmit} id="add-guest-group-form" className="add-guest-form col-xs-12">
          <div className="col-xs-12 col-sm-8">
            <FieldArray
              name="guests"
              component={RenderGuests}
              template={template}
              guestFormValues={guestFormValues}
            />
            <div className="row">
              <div className="col-xs-12 col-md-6">
                <div className="visible-xs visible-sm text-left">
                  <span className="form-label margin-right-1x">Relationship to You</span><div className="with-tooltip relationship-select-container" data-tooltip="Indicate how you know your guests to help filter your list."><i className="zolaicon zolaicon-info" /></div>
                  <Field
                    name="affiliation"
                    id="add-guest-group-guest-affiliation-test"
                    component={RenderDropdownSelect}
                    options={GuestAffiliation(wedding.owner_first_name, wedding.partner_first_name)}
                    tooltip="Indicate how you know your guests to help filter your list."
                    hideEmpty
                  />
                </div>
                {eventFormValues.length > 0 && (
                  <div className="visible-xs visible-sm ol-xs-12 col-sm-12 event-invitations text-left">
                    <FieldArray
                      name="event_invitations"
                      component={RenderEventInvitations}
                      label="Events Invited To"
                      id="event-invitations"
                      formValues={eventFormValues}
                      disabled={invitedFormValue === 'false'}
                    />
                  </div>
                )}
                <div className="visible-md visible-lg text-left">
                  <Field
                    name="affiliation"
                    id="add-guest-group-guest-affiliation-test"
                    component={RenderDropdownSelect}
                    options={GuestAffiliation(wedding.owner_first_name, wedding.partner_first_name)}
                    label="Relationship To You"
                    tooltip="Indicate how you know your guests to help filter your list."
                    hideEmpty
                  />
                </div>
              </div>
              {eventFormValues.length > 0 && (
                <div className="hidden-xs hidden-sm ol-xs-12 col-sm-12 event-invitations text-left">
                  <FieldArray
                    name="event_invitations"
                    component={RenderEventInvitations}
                    label="Events Invited To"
                    id="event-invitations"
                    formValues={eventFormValues}
                    disabled={invitedFormValue === 'false'}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-xs-12 col-sm-8">
            <div className="row">
              <div className="col-xs-12 col-md-6 text-left">
                <Field
                  name="email_address"
                  label="Email"
                  id="add-guest-group-email"
                  type="email"
                  formValues={guestFormValues}
                  component={RenderField}
                />
              </div>
              <div className="col-xs-12 col-md-6 text-left">
                <Field
                  name="mobile_phone"
                  label="Mobile"
                  id="add-guest-group-mobile-phone"
                  type="tel"
                  component={RenderField}
                />
              </div>
            </div>
            <div className="text-left">
              <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} value="Save" hideFormGroup />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

AddGuestGroupForm.propTypes = {
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string, // just for now
    partner_first_name: PropTypes.string
  }),
  template: PropTypes.string,
  guestFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  eventFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  invitedFormValue: PropTypes.string,
  // onGetGuestRequests: PropTypes.func,
  params: PropTypes.shape({}),
  grabGuest: PropTypes.func,
};

const selector = formValueSelector('addGuestGroupForm');

const mapStateToProps = (state) => {
  // const initialGuests = guestTemplates[ownProps.template] || guestTemplates.SINGLE;
  const eventInvitations = state.events.events.orderedIds.map((eventId) => {
    const event = state.events.events.byId[eventId];
    const eventInvitation = {
      name: event.name,
      event_id: eventId,
      checked: event.public,
      meal_option_id: null,
      rsvp_type: 'NO_RESPONSE',
      rsvp_at: null,
    };
    return eventInvitation;
  });

  const guestRequestByUuid = [state.publicWebsite.guestRequestByUuid];
  guestRequestByUuid[0].source = 'MANUAL';
  return {
    initialValues: {
      template: 'SINGLE',
      guests: guestRequestByUuid,
      invited: 'true',
      country_code: 'US',
      tier: 'A',
      affiliation: 'UNKNOWN',
      include_plus_one: 'false',
      event_invitations: eventInvitations,
      email_address: guestRequestByUuid[0].email_address,
    },
    template: selector(state, 'template'),
    invitedFormValue: selector(state, 'invited'),
    guestFormValues: selector(state, 'guests'),
    eventFormValues: selector(state, 'event_invitations') || [],
    wedding: state.wedding.wedding
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (createGuestGroupRequest) => {
    dispatch(addGuestFromRequestNotification(createGuestGroupRequest)).then(() => {
      if (ownProps.callback) ownProps.callback();
      dispatch(reset('addGuestGroupForm'));
    }).then(browserHistory.push('/wedding/manage/guests/rsvp-notifications'));
  },
  grabGuest: guestUuid => dispatch(grabGuestByUuid(guestUuid)),
  onGetGuestRequests: () => dispatch(getGuestRequests()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'addGuestGroupForm',
})(AddGuestGroupForm));



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addGuestPage/AddGuestPage.jsx